import { z } from 'zod';
import { jsonObject } from './common.js';
/**
 * THE single preview contract (F32, E10, CODE_GUIDELINES §9). `@xdocs/ui`
 * `<Preview descriptor={…}/>` switches on `kind`; explorer + discover consume
 * this one shape — no per-screen preview code.
 */
export const previewKind = z.enum([
    'image',
    'pdf',
    'docx',
    'audio',
    'book-cover',
    'text',
    'custom',
]);
export const previewDescriptor = z.object({
    kind: previewKind,
    thumbnailFileId: z.string().uuid().nullable(),
    posterUrl: z.string().url().optional(), // presigned, from cache
    aspectRatio: z.number().positive().optional(),
    meta: jsonObject.optional(),
});
